<template>
    <div class="material-table-expand" :class="{ other: params }">
        <div class="material-table-expand-con" v-loading="loading">
            <div class="material-table-expand-header" v-if="!params">
                <span>期望完成日期：{{ expandParams.expected_end_time }};</span>
                <span>投放场景：{{ expandParams.delivery_scene_name }};</span>
                <span>投放版位：{{ expandParams.delivery_type_name }};</span>
                <span v-if="expandParams.material_duration"
                    >素材时长：{{ expandParams.material_duration }}</span
                >
                <span
                    >素材标签：
                    <template
                        v-if="
                            expandParams.label_list &&
                            Array.isArray(expandParams.label_list) &&
                            expandParams.label_list.length !== 0
                        "
                    >
                        <span
                            v-for="(item, index) in expandParams.label_list"
                            :key="index"
                            class="pr6"
                            >{{ item.name }};</span
                        >
                    </template>
                    <span v-else>-</span>
                </span>
                <!-- <span
                    >制作人：
                    <template
                        v-if="
                            expandParams.producer &&
                            Array.isArray(expandParams.producer) &&
                            expandParams.producer.length !== 0
                        "
                    >
                        <span
                            v-for="(item, index) in expandParams.producer"
                            :key="index"
                            class="pr6"
                            >{{ item.num }} {{ item.user_name }};</span
                        >
                    </template>
                    <span v-else>-</span>
                </span> -->
            </div>
            <el-row
                class="tab-contant"
                type="flex"
                justify="space-between"
                align="middle"
            >
                <el-tabs
                    v-model="activeTableExpandName"
                    class="tabsMini"
                    @tab-click="handleClick"
                >
                    <el-tab-pane
                        :label="no_audit_list_text"
                        name="no_audit_list"
                    ></el-tab-pane>
                    <el-tab-pane
                        :label="rejected_no_modify_list_text"
                        name="rejected_no_modify_list"
                    ></el-tab-pane>
                    <el-tab-pane
                        :label="pass_list_text"
                        name="pass_list"
                    ></el-tab-pane>
                    <el-tab-pane name="rejected_and_modify_list">
                        <span slot="label">
                            <span>{{ rejected_and_modify_list_text }}</span>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="此处显示的素材为被拒绝且重新上传了素材的原素材，留底记录。"
                                placement="top"
                            >
                                <i class="el-icon-question"></i>
                            </el-tooltip>
                        </span>
                    </el-tab-pane>
                </el-tabs>
                
            </el-row>
            <div
                class="mb10 ml20 mt16"
                style="display: flex; align-items: center"
                v-if="list[activeTableExpandName].length != 0 && !params"
            >
                <el-button type="text" @click="handleSelect('all')"
                    >全选</el-button
                ><span :style="{ padding: '0 6px' }">/</span>
                <el-button type="text" @click="handleSelect('cannel')"
                    >反选</el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    v-if="getCurAuth('upload_material')"
                    :style="{ marginLeft: '30px' }"
                    plain
                    @click="handleGroupDown"
                    >批量下载</el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    plain
                    @click="handleGroupReject('group')"
                    v-if="
                        getCurAuth('batch_delete_material') &&
                        activeTableExpandName == 'no_audit_list' &&
                        tagsActive != 4
                    "
                    >批量删除</el-button
                >
                <!--                <el-button type="primary" size="mini"  @click="handleGroupPass">批量通过</el-button>-->
            </div>
            <div class="mb10 ml20 mt16" v-if="list[activeTableExpandName].length != 0 && params">
                <div
                    v-if="
                        activeTableExpandName == 'in_rejected_list' &&
                        tagsActive == '4'
                    "
                ></div>
                <div v-else>
                    <el-button type="text" @click="handleSelect('all')"
                        >全选</el-button
                    ><span :style="{ padding: '0 6px' }">/</span>
                    <el-button type="text" @click="handleSelect('cannel')"
                        >反选</el-button
                    >
                </div>
            </div>
            <div
                class="material-contant"
                v-if="list[activeTableExpandName].length != 0"
            >
                <div class="material-table-expand-cards">
                    <div
                        class="material-table-expand-cards-item"
                        v-for="(item, index) in list[activeTableExpandName]"
                        :key="index"
                        :title="activeTableExpandName"
                    >
                        <MaterialExtendItem
                            :expandMaterial="item"
                            :preview="false"
                            :fromTitle="`素材工单(任务管理-${info?.order_status_text})`"
                            @click-preview="handlePreView(item)"
                            :key="item.id"
                        >
                            <template v-slot:checkBox>
                                <el-checkbox
                                    :value="item.checked"
                                    @change="
                                        (value) => handleChange(value, index)
                                    "
                                ></el-checkbox>
                            </template>
                            <template v-slot:leftBtn>
                                <el-button
                                    type="primary"
                                    size="mini"
                                    plain
                                    v-if="getCurAuth('download_material')"
                                    :loading="item.downloading"
                                    v-matomo="{
                                        behaviorCategory: `素材工单(任务管理-${info?.order_status_text})`,
                                        event: '点击',
                                        name: '列表(查看-下载)',
                                    }"
                                    @click="handleOnlyDown(item)"
                                    >下载</el-button
                                >
                            </template>
                            <template v-slot:footer>
                                <div>
                                    <div
                                        v-if="
                                            activeTableExpandName ===
                                            'no_audit_list'
                                        "
                                    >
                                        <el-button
                                            type="primary"
                                            size="mini"
                                            v-if="getCurAuth('edit_material')"
                                            plain
                                            @click="handleEdit(item)"
                                            >编辑</el-button
                                        >
                                        <el-button
                                            type="danger"
                                            size="mini"
                                            v-if="getCurAuth('delete_material')"
                                            plain
                                            @click="
                                                () =>
                                                    handleGroupReject(
                                                        'only',
                                                        item.id
                                                    )
                                            "
                                            >删除</el-button
                                        >
                                    </div>
                                    <div
                                        v-else-if="
                                            activeTableExpandName ===
                                            'rejected_no_modify_list'
                                        "
                                    >
                                        <el-button
                                            type="primary"
                                            size="mini"
                                            v-if="
                                                getCurAuth(
                                                    'reupload_material'
                                                ) && tagsActive != 4
                                            "
                                            @click="handleReUpload(item)"
                                            >重新上传</el-button
                                        >
                                    </div>
                                    <div
                                        v-else-if="
                                            activeTableExpandName ===
                                            'pass_list'
                                        "
                                    >
                                        <el-button
                                            type="primary"
                                            size="mini"
                                            v-if="getCurAuth('edit_material')"
                                            plain
                                            @click="handleEdit(item)"
                                            >编辑</el-button
                                        >
                                    </div>
                                </div>
                            </template>
                        </MaterialExtendItem>
                    </div>
                    <!--使用占位元素,补齐最后一行空缺的item,以保证最后一行的展示效果-->
                    <!-- <div
                        class="pad-material-table-expand-cards-item material-table-expand-cards-item"
                        v-for="index of padNum"
                        :key="index + activeTableExpandName"
                    ></div> -->
                </div>
            </div>
            <div v-else :style="{ textAlign: 'center', lineHeight: '60px' }">
                暂无数据
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex"
import MaterialExtendItem from "@/views/workOrder/components/materialExtendItem.vue"
import { cloneDeep } from "lodash"
import API from "@/api/workOrder/material.js"
import { storePreviewModal, uploadMaterialModal } from "@/views/workOrder/modal"
import { downLoadModal, rejectModal } from "./modal"
import { downloadFile } from "@/views/workOrder/components/utils.js"
import matomoFun from "@/utils/matomo.js"
export default {
    name: "taskInfo_tableExpand",
    components: {
        MaterialExtendItem,
    },
    props: [
        "pageFuncNames",
        "orderId",
        "params",
        "rows",
        "show_status",
        "tagsActive",
        "info",
        "showBar",
    ],
    data() {
        return {
            activeTableExpandName: "no_audit_list",
            checked: true,
            list: {
                no_audit_list: [],
                rejected_no_modify_list: [],
                pass_list: [],
                rejected_and_modify_list: [],
            },
            // rows:{},
            expandParams: {},
            no_audit_list_text: "待审核",
            rejected_no_modify_list_text: "被拒绝未修改",
            pass_list_text: "已通过",
            rejected_and_modify_list_text: "被拒绝已修改",
            expandMaterial: [],
            loading: false,
            padNum: 0,
            authDownHref:
                "/td/api/order_task/detail_material/download_material",
            propsList: [],
        }
    },
    computed: {
        ...mapState({
            sidebarOpened: (state) => state.app.sidebar.opened,
        }),
    },
    watch: {
        // showBar() {
        //     setTimeout(() => {
        //         this.getPadNum()
        //     }, 300)
        // },
        // sidebarOpened() {
        //     setTimeout(() => {
        //         this.getPadNum()
        //     }, 300)
        // },
    },
    mounted() {
        this.getInfo("init")
        document
            .querySelector(".tabsMini")
            .addEventListener("click", this.handleScroll)
        // this.getPadNum()
        // window.addEventListener("resize", this.getPadNum)
    },
    methods: {
        // getPadNum() {
        //     /* 动态计算最后一行的数量 */
        //     const width = document.querySelector(
        //         ".material-table-expand-con"
        //     )?.clientWidth
        //     // console.log('width',width);
        //     const rowNum = Math.floor(width / (300 + 10))
        //     if (this.list[this.activeTableExpandName].length % rowNum != 0) {
        //         let padNum =
        //             rowNum -
        //             (this.list[this.activeTableExpandName].length % rowNum)
        //         this.padNum = padNum
        //     } else {
        //         this.padNum = 0
        //     }
        // },
        handleScroll(e) {
            let target = e.target
            if (target.className.indexOf("el-tabs__item") > -1) {
                //数组取整
                let cur_top = parseInt(target.getBoundingClientRect().top)
                let curDom = document.querySelector(
                    ".scrollbar-wrapper-78778965"
                )
                let srollTop = parseInt(curDom.scrollTop)
                const targetPosition = srollTop + cur_top - 130
                if (targetPosition > 100) {
                    curDom.scrollTo({
                        top: targetPosition,
                        behavior: "smooth",
                    })
                } else {
                    curDom.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    })
                }
            }
        },
        // 操作权限
        getCurAuth(name) {
            return this.pageFuncNames.includes(name)
        },
        getInfo(type, noloading = true) {
            if (noloading) {
                this.loading = true
            }
            if (this.params) {
                return API.getWorkTaskDetailByOrderList({
                    order_id: this.orderId,
                    ...this.params,
                }).then(
                        (res) => {
                            this.expandParams = res.data
                            this.$nextTick(() => {
                                this.no_audit_list_text = `待审核（${
                                    this.expandParams?.no_audit_num
                                        ? this.expandParams?.no_audit_num
                                        : 0
                                }）`
                                this.rejected_no_modify_list_text = `被拒绝未修改（${
                                    this.expandParams?.rejected_no_modify_num
                                        ? this.expandParams
                                              ?.rejected_no_modify_num
                                        : 0
                                }）`
                                this.pass_list_text = `已通过（${
                                    this.expandParams?.pass_num
                                        ? this.expandParams?.pass_num
                                        : 0
                                }）`
                                this.rejected_and_modify_list_text = `被拒绝已修改（${
                                    this.expandParams?.rejected_and_modify_num
                                        ? this.expandParams
                                              ?.rejected_and_modify_num
                                        : 0
                                }）`
                                const list_keys = Object.keys(this.list)
                                // this.handleClick({name:'no_audit_list'})
                                let new_list = {}
                                list_keys.forEach((ele) => {
                                    let res_list = this.expandParams[ele]
                                        ? this.expandParams[ele]
                                        : []
                                    new_list[ele] = res_list.map((item) => {
                                        item["type"] = ele
                                        // item['checked'] = false;
                                        item["reUpload"] = false
                                        item["all_labels"] = (
                                            item.delete_labels || []
                                        ).concat(item.label_list || [])

                                        this.list[ele] &&
                                            this.list[ele].map((item2) => {
                                                item2["downloading"] = false
                                                if (item2.id === item.id) {
                                                    item["checked"] =
                                                        item2["checked"]
                                                }
                                            })

                                        return item
                                    })
                                })
                                this.list = new_list
                                if (type === "init" && this.show_status) {
                                    this.activeTableExpandName = this
                                        .show_status
                                        ? this.show_status
                                        : "no_audit_list"
                                }
                            })
                        },
                        (err) => {
                            this.$message.error(err.info)
                        }
                    )
                    .finally(() => {
                        this.loading = false
                        // this.getPadNum()
                    })
            } else {
                return API.getWorkTaskMaterialList({
                    detail_id: this.rows.id,
                    assign_id: this.rows.assign_id,
                })
                    .then(
                        (res) => {
                            this.expandParams = res.data
                            this.$nextTick(() => {
                                this.no_audit_list_text = `待审核（${
                                    this.expandParams?.material_list
                                        ?.no_audit_num
                                        ? this.expandParams?.material_list
                                              ?.no_audit_num
                                        : 0
                                }）`
                                this.rejected_no_modify_list_text = `被拒绝未修改（${
                                    this.expandParams?.material_list
                                        ?.rejected_no_modify_num
                                        ? this.expandParams?.material_list
                                              ?.rejected_no_modify_num
                                        : 0
                                }）`
                                this.pass_list_text = `已通过（${
                                    this.expandParams?.material_list?.pass_num
                                        ? this.expandParams?.material_list
                                              ?.pass_num
                                        : 0
                                }）`
                                this.rejected_and_modify_list_text = `被拒绝已修改（${
                                    this.expandParams?.material_list
                                        ?.rejected_and_modify_num
                                        ? this.expandParams?.material_list
                                              ?.rejected_and_modify_num
                                        : 0
                                }）`
                                const list_keys = Object.keys(this.list)
                                // this.handleClick({name:'no_audit_list'})
                                let new_list = {}
                                list_keys.forEach((ele) => {
                                    let res_list = this.expandParams
                                        ?.material_list[ele]
                                        ? this.expandParams?.material_list[ele]
                                        : []
                                    new_list[ele] = res_list.map((item) => {
                                        item["type"] = ele
                                        // item['checked'] = false;
                                        item["reUpload"] = false
                                        item["all_labels"] = (
                                            item.delete_labels || []
                                        ).concat(item.label_list || [])

                                        this.list[ele] &&
                                            this.list[ele].map((item2) => {
                                                item2["downloading"] = false
                                                if (item2.id === item.id) {
                                                    item["checked"] =
                                                        item2["checked"]
                                                }
                                            })

                                        return item
                                    })
                                })
                                this.list = new_list
                                if (type === "init" && this.show_status) {
                                    this.activeTableExpandName = this
                                        .show_status
                                        ? this.show_status
                                        : "no_audit_list"
                                }
                            })
                        },
                        (err) => {
                            this.$message.error(err.info)
                        }
                    )
                    .finally(() => {
                        if (noloading) {
                            this.loading = false
                        }
                        // this.getPadNum()
                    })
            }
        },
        // 折角矩形 标签点击
        handleClick(val) {
            // let res_list = this.expandParams?.material_list[val.name] ? this.expandParams?.material_list[val.name] : []
            // this.list[val.name] = res_list.map(item=>{item['type'] = val.name;item['checked'] = true; return item})
            // console.log('list', this.list)
            // this.getPadNum()
        },
        // 设置 选中
        handleChange(value, index) {
            console.log(value, index)
            this.$set(this.list[this.activeTableExpandName], index, {
                ...this.list[this.activeTableExpandName][index],
                checked: value,
            })
            this.$nextTick(() => {
                let group_ids = this.list[this.activeTableExpandName]
                    .filter((item) => item["checked"])
                    .map((item) => item["id"])
                console.log("---", group_ids)
            })
        },
        // 全选 反选
        handleSelect(type) {
            let res_obj = []
            let cloneDeepList = cloneDeep(this.list[this.activeTableExpandName])
            if (type == "all") {
                if (cloneDeepList.every((item) => item["checked"])) {
                    res_obj = cloneDeepList.map((item) => {
                        item["checked"] = false
                        return item
                    })
                } else {
                    res_obj = cloneDeepList.map((item) => {
                        item["checked"] = true
                        return item
                    })
                }
            } else {
                res_obj = cloneDeepList.map((item) => {
                    item["checked"] = !item["checked"]
                    return item
                })
            }
            this.$set(this.list, this.activeTableExpandName, res_obj)

            this.$nextTick(() => {
                let group_ids = this.list[this.activeTableExpandName]
                    .filter((item) => item["checked"])
                    .map((item) => item["id"])
                console.log("---", group_ids)
            })
        },
        // 批量下载
        handleGroupDown() {
            let group_ids = this.list[this.activeTableExpandName]
                .filter((item) => item["checked"])
                .map((item) => item["id"])
            if (!group_ids || group_ids.length == 0) {
                return this.$message.warning("请选择素材后操作")
            }
            const { vm } = downLoadModal({
                props: {
                    id: group_ids,
                    name: `素材工单(任务管理-${this.info?.order_status_text})`,
                    desc: "列表(查看-批量下载-",
                    // orderId: this.orderId
                },
                cbs: {
                    onSubmit: (data) => {
                        vm.close()
                    },
                },
                on: {
                    close: () => {
                        vm.close()
                        matomoFun.trackEvent(
                            `素材工单(任务管理-${this.info?.order_status_text})`,
                            "点击",
                            "列表(查看-批量下载-取消)"
                        )
                    },
                },
            })
        },
        // 单独下载
        handleOnlyDown(row) {
            let index = this.list[this.activeTableExpandName].findIndex(
                (item) => item["id"] == row.id
            )
            this.$set(
                this.list[this.activeTableExpandName][index],
                "downloading",
                true
            )
            API.postOrderTaskOnlyDownLoad({ material_id: row.id })
                .then(
                    (res) => {
                        let result = res.data
                        downloadFile(result)
                    },
                    (err) => {
                        this.$message.error(err.info || "请求异常")
                    }
                )
                .finally(() => {
                    this.$set(
                        this.list[this.activeTableExpandName][index],
                        "downloading",
                        false
                    )
                })
        },
        // downloadFile(params) {
        //     let url = `/td/api/download?name=${encodeURIComponent(params.name)}&path=${encodeURI(params.path)}`
        //     try{
        //         let elemIF = document.createElement("iframe");
        //         elemIF.src = url;
        //         elemIF.style.display = "none";
        //         document.body.appendChild(elemIF);
        //         setTimeout(()=>{
        //             elemIF.remove();
        //         },1000*50)
        //     }catch(e){
        //         console.log('exportFile error',e);
        //     }
        // },
        // 批量删除
        handleGroupReject(type, id) {
            let group_ids = []
            if (type == "group") {
                group_ids = this.list[this.activeTableExpandName]
                    .filter((item) => item["checked"])
                    .map((item) => item["id"])
                if (!group_ids || group_ids.length == 0) {
                    return this.$message.warning("请选择素材后操作")
                }
                const { vm } = rejectModal({
                    props: {
                        fetch: "postWorkTaskBatchDeleteExpand",
                        postItems: { material_id: group_ids },
                        name: `素材工单(任务管理-${this.info?.order_status_text})`,
                        desc: "列表(查看-批量删除-提交)",
                    },
                    cbs: {
                        onSubmit: (data) => {
                            vm.close()
                            this.getInfo()
                            if (!this.params) {
                                this.$emit("reloadColumn", this.rows.assign_id)
                            }
                        },
                    },
                    on: {
                        close: () => {
                            vm.close()
                            matomoFun.trackEvent(
                                `素材工单(任务管理-${this.info?.order_status_text})`,
                                "点击",
                                "列表(查看-批量删除-取消)"
                            )
                        },
                    },
                })
            } else {
                group_ids = [id]
                // API.postWorkTaskBatchDelete({material_id:group_ids}).then(res=>{
                //     this.$message.success(res.info)
                //     this.getInfo()
                // }, err=>{
                //     this.$message.error(err.info)
                // })
                const { vm } = rejectModal({
                    props: {
                        fetch: "postWorkTaskBatchDelete",
                        postItems: { material_id: group_ids },
                    },
                    cbs: {
                        onSubmit: (data) => {
                            vm.close()
                            this.getInfo()
                            if (!this.params) {
                                this.$emit("reloadColumn", this.rows.assign_id)
                            }
                        },
                    },
                })
            }
        },
        // 素材预览
        handlePreView(params) {
            const { vm } = storePreviewModal({
                props: {
                    id: params.id,
                    list: this.list[this.activeTableExpandName],
                    activeTabs: this.activeTableExpandName,
                    fetch: "getOrderPreview", //请求不同给的接口rejected_and_modify_list
                    authEdit:
                        this.activeTableExpandName ==
                            "rejected_no_modify_list" ||
                        this.activeTableExpandName == "rejected_and_modify_list"
                            ? false
                            : this.getCurAuth("edit_material"), //被拒绝未修改 没有编辑能力
                    authDown: this.getCurAuth("download_material"),
                    downFetch: "postOrderTaskOnlyDownLoad",
                    authDownHref: this.authDownHref,
                    authReUpload:
                        this.activeTableExpandName ==
                            "rejected_no_modify_list" && this.tagsActive != 4
                            ? this.getCurAuth("reupload_material")
                            : false, //被拒绝未修改 可以重新上传
                    authDel:
                        this.activeTableExpandName == "no_audit_list" &&
                        this.tagsActive != 4
                            ? this.getCurAuth("delete_material")
                            : false,
                },
                cbs: {
                    onSubmit: (data) => {
                        console.log("触发详情关闭", data)
                    },
                    onEdit: (data) => {
                        let rowData = this.list[
                            this.activeTableExpandName
                        ].find((item) => item.md5 == data.md5)
                        console.log("rowData", rowData, data)
                        this.handleEdit(rowData || data)
                    },
                    onReload: (data) => {
                        vm.close()
                        setTimeout(() => {
                            this.handleReUpload(params)
                        }, 200)
                    },
                    onDelete: async (data) => {
                        await this.getInfo()
                        vm.$refs.componentVm._list =
                            this.list[this.activeTableExpandName]

                        if (!this.params) {
                            this.$emit("reloadColumn", this.rows.assign_id)
                        }
                    },
                },
            })
        },
        // 单个 上传编辑
        handleEdit(item) {
            console.log("handleEdit", item, this.rows)
            let rows = this.expandParams || {}
            uploadMaterialModal({
                props: {
                    title: "素材编辑",
                    isBatch: false,
                    isEdit: true,
                    materialInfo: Object.assign(
                        {},
                        { ...item },
                        {
                            source: "1",
                            assign_id: rows.assign_id,
                            task_id: rows.id,
                            app_type: rows.app_type,
                            game_classify: rows.game_classify,
                            project_id: rows.project_id,
                            project_name: rows.project_name,
                            package_type: rows.package_type,
                        }
                    ),
                },
                cbs: {
                    onSubmit: (data) => {
                        console.log("触发详情关闭", data)
                        this.getInfo()
                    },
                },
            })
        },
        handleReUpload(item) {
            if (item.reUpload)
                return this.$message.error("当前素材状态改变，请刷新列表")
            let rows = this.expandParams || {}
            uploadMaterialModal({
                props: {
                    title: "重新上传素材",
                    isBatch: false,
                    isEdit: false,
                    isReUpload: true,
                    orderInfo: { ...this.info },
                    taskList: [this.rows],
                    materialInfo: Object.assign(
                        {},
                        { ...item },
                        {
                            source: "1",
                            assign_id: rows.assign_id,
                            task_id: rows.id,
                            app_type: rows.app_type,
                            game_classify: rows.game_classify,
                            project_id: rows.project_id,
                            project_name: rows.project_name,
                            package_type: rows.package_type,
                        }
                    ),
                },
                cbs: {
                    onSubmit: (data) => {
                        console.log("触发详情关闭", data)
                        // this.$refs.queryRef.handleOnSubmit();
                        this.$store.commit("workOrder/ADD_WORK_TASK_ITEM", data)
                        this.$set(item, "reUpload", true)
                        if (!this.params) {
                            this.$emit("reloadColumn", this.rows.assign_id)
                        }
                    },
                },
            })
        },
    },
    beforeDestroy() {
        document.querySelector(".tabsMini") &&
            document
                .querySelector(".tabsMini")
                .removeEventListener("click", this.handleScroll)
        // window.removeEventListener("resize", this.getPadNum)
    },
}
</script>
<style lang="scss" scoped>
.material-table-expand {
    height: 100%;
    padding: 0 10px;

    .material-table-expand-con {
        height: 100%;
        background-color: #f1f4f9;
        border-radius: 8px; // 添加圆角
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); // 添加阴影
    }

    .material-table-expand-header {
        display: flex;
        flex-wrap: wrap;
        padding: 8px 10px 0;

        span {
            padding-right: 20px;
            padding-bottom: 6px;
        }
    }

    // .material-table-expand-cards {
    //     display: flex;
    //     flex-wrap: wrap;
    //     justify-content: space-evenly;
    //     .pad-material-table-expand-cards-item {
    //         background-color: transparent !important;
    //         width: 300px;
    //     }

    //     .material-table-expand-cards-item:not(.pad-material-table-expand-cards-item) {
    //         background-color: #fff;
    //         margin: 0 5px 10px 5px;
    //         border-radius: 8px; // 添加圆角
    //         box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); // 添加阴影
    //         transition: box-shadow 0.3s ease; // 添加过渡效果

    //         &:hover {
    //             box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); // 鼠标悬停时增强阴影
    //         }
    //     }
    // }
    .material-table-expand-cards {
        display: grid;
        grid-template-columns: repeat(auto-fill, 310px);
        gap: 20px;
        justify-content: center;
        .material-table-expand-cards-item {
            background-color: #fff;
            margin: 0 5px 10px 5px;
            border-radius: 8px; // 添加圆角
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); // 添加阴影
            transition: box-shadow 0.3s ease; // 添加过渡效果

            &:hover {
                box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); // 鼠标悬停时增强阴影
            }
        }
    }
    .pr6 {
        padding-right: 6px !important;
    }
    .tabsMini {
        flex: 1;
        background-color: #fff;
        padding-left: 20px;
        .el-tabs__item {
            font-size: 12px;
            line-height: 30px;
            height: 30px;
        }
        ::v-deep .el-tabs__header {
            margin-bottom: 0;
        }
    }
    &.other {
        padding: 0;

        .material-table-expand-con {
            display: flex;
            flex-direction: column;

            .tab-contant {
                background: #fff;
            }

            .material-contant {
                flex: 1;
                overflow-y: auto;
                height: 0;

                .material-table-expand-cards {
                    padding-top: 10px;
                }
            }
        }
    }
}
</style>
